import { useMutation } from 'react-query';
import { logPageClick } from 'new/modules/AnalyticDashboardPage/endpoints';
import { LogPageClickRequest } from 'new/modules/Setup/types';

export const usePageClick = () =>
  useMutation<unknown, unknown, LogPageClickRequest>((params) =>
    logPageClick.endpoint(params),
  );
